import { render, staticRenderFns } from "./release-process.vue?vue&type=template&id=5dd56d40&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd56d40",
  null
  
)

export default component.exports